import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
// testing for board
import Vue from 'vue';
import Vuex from 'vuex';
import { getLastSpecificDocumentsApi, getLastDocumentApi, getFactoriesInfoApi, getAllGroupsApi, getAllAlarmsApi, getSortedFactoriesApi, getOtherSystemFactoriesApi } from '@/api';
import router from '@/router';
import siteInfoDetail from './modules/siteInfoDetail';
import deviceStatus from './modules/deviceStatus';
import deviceHistory from './modules/deviceHistory';
import ChartsAndBarItem from './modules/ChartsAndBarItem';
import pvStringFailure from './modules/pvStringFailure';
import projectEnergy from './modules/projectEnergy';
import calculate from '@/utils/calculate';
import { removeDuplicates } from '@/utils/removeDuplicates';
import renderTableData from './function/deviceStatus/tableRender';
import { dbDataHandle, updateFactoryData, handleIRRArray, decryptData } from './function/common/index';
import Highcharts from 'highcharts';
import { isNumber } from '@/utils/is';
Vue.use(Vuex);

/**
 * 取換機保留發電量的有效值。
 *
 * initAckwhValue[i] 是該台 INV 歷次換機時「累計保留基準」的快照陣列，語意上只增不減。
 * 原本取最後一筆，但實務上會出現操作者誤填的紀錄（填成新機當下讀數而非累計基準，
 * 如鉅橡 INV19 的 [328499.6, 192.1]），一取最後一筆就把三十幾萬 kWh 的基準吃掉。
 * 改取最大值：正常情況最後一筆就是最大值，誤填的小值會被忽略。
 * 後端 factories.controller.js 有同名同邏輯的函式，兩邊要一起改。
 *
 * @param {Array<number>} values initAckwhValue 中該台 INV 的快照陣列
 * @returns {number} 保留發電量 (kWh)，無有效值時回 0
 */
var getRetainedAckwh = function getRetainedAckwh(values) {
  if (!Array.isArray(values) || !values.length) return 0;
  var nums = values.filter(function (v) {
    return Number.isFinite(v);
  });
  return nums.length ? Math.max.apply(Math, _toConsumableArray(nums)) : 0;
};

// ----- chart theme -----
var chartTheme = {
  accessibility: {
    enabled: false
  },
  lang: {
    thousandsSep: ',',
    // 千分位符號
    resetZoom: '重置縮放' // 自訂文字
  }
};
Highcharts.setOptions(chartTheme);
function getWindDirection(degree) {
  var directions = ['北', '北東北', '東北', '東東北', '東', '東東南', '東南', '南東南', '南', '南西南', '西南', '西西南', '西', '西西北', '西北', '北西北'];

  // 將度數轉換為方向索引 (16等分)
  var index = Math.round(degree / 22.5) % 16;
  return directions[index];
}

// --- demo、factory 可能重複 ---
function queryFactoryList(_ref) {
  var _userDetail$factories;
  var userDetail = _ref.userDetail,
    hasFactoryPermission = _ref.hasFactoryPermission,
    hasDemoPermission = _ref.hasDemoPermission;
  // has 'ALL'
  if (((_userDetail$factories = userDetail.factoriesList) === null || _userDetail$factories === void 0 ? void 0 : _userDetail$factories[0]) === 'ALL') return ['ALL'];

  // only demo
  if (!hasFactoryPermission && hasDemoPermission) {
    return userDetail.demoList;
  }

  // only factory
  if (hasFactoryPermission && !hasDemoPermission) {
    return userDetail.factoriesList;
  }

  // not 'ALL', has demo & factory
  var queryList = [].concat(_toConsumableArray(userDetail.demoList), _toConsumableArray(userDetail.factoriesList));
  return _toConsumableArray(new Set(queryList));
}
var state = {
  minDataLastTime: '',
  globalFactory: '',
  roleAdmin: ['Whole_Admin', 'OM_Head', 'Admin'],
  dataAnalysisChooseTimeAdmin: ['Whole_Admin', 'OM_Head', 'Admin', '工務'],
  dataAdmin: ['Whole_Admin', 'Admin'],
  realTimeDataReload: true,
  userDetail: {
    account: '',
    displayName: '',
    factoriesList: [''],
    demoList: [''],
    id: '',
    role: ''
  },
  hasRoleAdmin: false,
  // 可看 roleAdmin 權限資料
  hasDataAnalysisTimePermission: false,
  // 可看 dataanalysis '時' 資料
  hasFactoryPermission: false,
  // 可看案場
  hasDemoPermission: false,
  // 可看 demo
  querySiteName: '',
  // call api 時的 site name
  factoryData: [],
  factoryInfo: [],
  hasGotForeignList: false,
  foreignFactoryList: [],
  sortedFactoryNameList: [],
  alarmAmountData: {},
  factoryError: [],
  capacity: [],
  // 發電時數: acp / cap
  alertData: [],
  overlayShow: true,
  timer: '',
  isNewData: true,
  dark: false,
  tableThColor: 'light',
  lastMonAcpIrr: {},
  // msalInstance: null,
  realTimeRePostBeginTime: null,
  roleArray: [],
  roleComponentMenu: [],
  // 可看 siteInfo top 相關頁面權限
  roleOthersMenu: [],
  // 其他按鈕權限
  solarPermissionArray: [],
  // 可看太陽能雲端 solar sideMenu 頁面權限
  energyPermissionArray: [],
  // 可看可視化 energy sideMenu 頁面權限
  roomPermissionArray: [],
  // 可看戰情室 room sideMenu 頁面權限
  otherSourcesPermissionArray: [],
  // 可看其他監控來源 sideMenu 頁面權限
  projects: [],
  invAckwhRetention: {
    switchInverterIndex: [],
    initAckwhTs: [[]],
    initAckwhValue: [[]]
  }
};
var getters = {
  // realtime factoryNameList options
  getFactoryInfoNameList: function getFactoryInfoNameList(state) {
    return state.factoryInfo.map(function (item) {
      return item.displaySiteName;
    });
  }
};
var mutations = {
  ADD_USER_DETAIL: function ADD_USER_DETAIL(state, payload) {
    var _state$userDetail$fac, _state$userDetail$dem;
    state.userDetail = payload;

    // 可觀看案場
    state.hasFactoryPermission = ((_state$userDetail$fac = state.userDetail.factoriesList) === null || _state$userDetail$fac === void 0 ? void 0 : _state$userDetail$fac[0]) !== '無';

    // 可觀看 demo
    state.hasDemoPermission = ((_state$userDetail$dem = state.userDetail.demoList) === null || _state$userDetail$dem === void 0 ? void 0 : _state$userDetail$dem[0]) !== '無';

    // 可看告警 等等權限
    state.hasRoleAdmin = state.roleAdmin.includes(state.userDetail.role);

    // 可看資料分析頁 選擇、查看 '時' 資料
    state.hasDataAnalysisTimePermission = state.dataAnalysisChooseTimeAdmin.includes(state.userDetail.role) || state.userDetail.account === 'yunbao' && state.userDetail.displayName === '雲豹能源';
    // 開放雲豹可觀看
  },
  CHANGE_GOT_FOREIGN_FACTORY_STATE: function CHANGE_GOT_FOREIGN_FACTORY_STATE(state, payload) {
    state.hasGotForeignList = payload;
  },
  ADD_FOREIGN_FACTORY_LIST: function ADD_FOREIGN_FACTORY_LIST(state, payload) {
    state.foreignFactoryList = payload;
  },
  ADD_SORTED_FACTORY_NAME_LIST: function ADD_SORTED_FACTORY_NAME_LIST(state, payload) {
    state.sortedFactoryNameList = payload;
  },
  ADD_FACTORY_INFO: function ADD_FACTORY_INFO(state, payload) {
    // all data
    state.factoryInfo = payload;
    var factoryInfoKeyArray = ['factoryAppName', 'systemStartupDate', 'powerStartupDate', 'projectNumber', 'caseOrientation', 'caseArea', 'country', 'county', 'district', 'moduleType', 'moduleCounts', 'moduleBevel', 'highVoltageParallel', 'caseSite', 'contactPerson', 'longitude', 'latitude', 'unitPrice', 'warrantyStartDate', 'warrantyDueDate', 'presetIrrModule', 'invModule', 'caseCapacity', 'caseCapacityInt', 'moduleOrientation', 'omPrincipal', 'omNumber', 'acmeStatus', 'powerPlantTag', 'ipCam'];
    state.siteInfoDetail.groupNumber = 0;
    var _iterator = _createForOfIteratorHelper(payload),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var val = _step.value;
        if (state.querySiteName === val.factory) {
          (function (_Object$keys) {
            var infoData = _objectSpread(_objectSpread({}, val.informations), {}, {
              factoryAppName: val.informations.factoryAppName
            });
            var keysLengthNotEqualDataLength = ((_Object$keys = Object.keys(infoData)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) !== factoryInfoKeyArray.length;
            if (keysLengthNotEqualDataLength) {
              // 將資料補足 ex: data 可能沒有 powerStartupDate
              factoryInfoKeyArray.forEach(function (x) {
                if (!infoData[x]) {
                  infoData[x] = '';
                }
              });
            }
            var informationsArr = Object.entries(infoData).sort(function (a, b) {
              return factoryInfoKeyArray.indexOf(a[0]) - factoryInfoKeyArray.indexOf(b[0]);
            });
            state.siteInfoDetail.siteInfoValue = Object.fromEntries(informationsArr);
            state.siteInfoDetail.weatherLonAndLat.lon = state.siteInfoDetail.siteInfoValue.longitude;
            state.siteInfoDetail.weatherLonAndLat.lat = state.siteInfoDetail.siteInfoValue.latitude;
            state.siteInfoDetail.uluru.lng = state.siteInfoDetail.siteInfoValue.longitude;
            state.siteInfoDetail.uluru.lat = state.siteInfoDetail.siteInfoValue.latitude;
            if (val.linkGroupNumber) {
              state.siteInfoDetail.groupNumber = val.linkGroupNumber;
            }
            state.siteInfoDetail.ipCamNum = val.ipCamNum;
          })();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  ADD_FACTORY_DATA: function ADD_FACTORY_DATA(state, payload) {
    var hasDemo = payload.find(function (item) {
      return item.isDemoSite;
    });
    if (hasDemo) {
      var demoList = [];
      var factoryList = [];
      state.factoryData = state.factoryData.concat(payload);
      state.factoryData.forEach(function (item) {
        if (item.isDemoSite) return demoList.push(item);
        if (!item.isDemoSite) return factoryList.push(item);
      });
      demoList = demoList.sort(function (a, b) {
        return a.displaySiteName.split(' ')[1] - b.displaySiteName.split(' ')[1];
      });
      state.factoryData = [].concat(_toConsumableArray(demoList), factoryList);
    }
    if (!hasDemo) {
      // 濾除 undefined
      state.factoryData = state.factoryData.concat(payload).filter(function (i) {
        return i;
      });
    }

    // filter repeat
    state.factoryData = removeDuplicates(state.factoryData, 'displaySiteName');
  },
  ADD_QUERY_SITE_NAME: function ADD_QUERY_SITE_NAME(state, payload) {
    state.querySiteName = payload;
    var hasDemo = payload === null || payload === void 0 ? void 0 : payload.includes('展示案場 ');
    if (hasDemo) {
      var demoIndex = payload.split(' ')[1] - 1;
      state.querySiteName = state.factoryInfo[demoIndex].factory;
    }
  },
  UPDATE_DATA_ANALYSIS_STATE: function UPDATE_DATA_ANALYSIS_STATE(state) {
    state.factoryData.forEach(function (item) {
      if (state.querySiteName === (item === null || item === void 0 ? void 0 : item.factoryName)) {
        state.capacity = item.capacity;
        state.siteInfoDetail.capacity = item.capacity;
      }
    });
  },
  SET_INV_ACKWH_RETENTION: function SET_INV_ACKWH_RETENTION(state, payload) {
    state.invAckwhRetention = payload || {
      switchInverterIndex: [],
      initAckwhTs: [[]],
      initAckwhValue: [[]]
    };
  },
  CHANGE_DARK_MODE: function CHANGE_DARK_MODE(state) {
    state.dark = true;
    state.tableThColor = 'dark';
  },
  CHANGE_LIGHT_MODE: function CHANGE_LIGHT_MODE(state) {
    state.dark = false;
    state.tableThColor = 'light';
  },
  CHANGE_REALTIME_RELOAD: function CHANGE_REALTIME_RELOAD(state, payload) {
    state.realTimeDataReload = payload;
  },
  LAST_MON_ACP_IRR: function LAST_MON_ACP_IRR(state, payload) {
    state.lastMonAcpIrr = payload;
  },
  // ASSIGN_MSAL (state, payload) {
  //   state.msalInstance = payload
  // },
  RESET_FACTORY_DATA: function RESET_FACTORY_DATA(state) {
    state.factoryData = [];
  },
  SET_ROLE_ARRAY: function SET_ROLE_ARRAY(state, payload) {
    state.roleArray = payload;
  },
  UPDATE_ROLE_ARRAY: function UPDATE_ROLE_ARRAY(state) {
    if (router.currentRoute.name === 'tvscreen') return; // tvscreen 不檢查權限

    var roleMenu = state.roleArray.find(function (x) {
      return x.role === state.userDetail.role;
    });
    if (roleMenu) {
      var _roleMenu$otherSites$, _roleMenu$otherSites$2, _roleMenu$otherSites$3, _roleMenu$otherSites$4, _roleMenu$otherSites$5, _roleMenu$otherSites$6;
      state.roleComponentMenu = roleMenu.componentMenu;
      state.roleOthersMenu = roleMenu.othersMenu;
      state.solarPermissionArray = roleMenu.sideMenu || [];
      state.energyPermissionArray = ((_roleMenu$otherSites$ = roleMenu.otherSites.filter(function (x) {
        return x.name === 'projectEnergy';
      })) === null || _roleMenu$otherSites$ === void 0 ? void 0 : (_roleMenu$otherSites$2 = _roleMenu$otherSites$[0]) === null || _roleMenu$otherSites$2 === void 0 ? void 0 : _roleMenu$otherSites$2.sideMenu) || [];
      state.roomPermissionArray = ((_roleMenu$otherSites$3 = roleMenu.otherSites.filter(function (x) {
        return x.name === 'projectSituationRoom';
      })) === null || _roleMenu$otherSites$3 === void 0 ? void 0 : (_roleMenu$otherSites$4 = _roleMenu$otherSites$3[0]) === null || _roleMenu$otherSites$4 === void 0 ? void 0 : _roleMenu$otherSites$4.sideMenu) || [];
      state.otherSourcesPermissionArray = ((_roleMenu$otherSites$5 = roleMenu.otherSites.filter(function (x) {
        return x.name === 'projectOtherSources';
      })) === null || _roleMenu$otherSites$5 === void 0 ? void 0 : (_roleMenu$otherSites$6 = _roleMenu$otherSites$5[0]) === null || _roleMenu$otherSites$6 === void 0 ? void 0 : _roleMenu$otherSites$6.sideMenu) || [];
    } else {
      Vue.swal('無此權限');
      state.roleComponentMenu = [];
      state.roleOthersMenu = [];
      state.solarPermissionArray = [];
      state.energyPermissionArray = [];
      state.roomPermissionArray = [];
      state.otherSourcesPermissionArray = [];
    }
  },
  SET_PROJECTS: function SET_PROJECTS(state) {
    var hasSolarBtn = state.solarPermissionArray.length;
    var hasEnergyBtn = state.energyPermissionArray.length;
    var hasOtherSourcesBtn = state.otherSourcesPermissionArray.length;
    var checkList = [hasSolarBtn, hasEnergyBtn, hasOtherSourcesBtn];
    var allProjects = [{
      label: '雲端監控中心',
      icon: 'fas fa-solar-panel',
      homePageName: state.solarPermissionArray[0] // 專案首頁名稱, 依據權限不同
      // iconSize: 16
    }, {
      label: '電能可視化管理',
      icon: 'fas fa-bolt',
      homePageName: state.energyPermissionArray[0]
      // iconSize: 16
    }, {
      // 第三方監控平台 API，權限在群組管理的「其他監控來源」設定
      label: '其他監控來源',
      icon: 'fas fa-plug',
      homePageName: state.otherSourcesPermissionArray[0]
    }];
    state.projects = allProjects.filter(function (_item, index) {
      return checkList[index];
    });
  },
  ADD_ALARM_DATA: function ADD_ALARM_DATA(state, payload) {
    state.alarmAmountData = payload;
  },
  SET_IS_NEW_DATA: function SET_IS_NEW_DATA(state, payload) {
    state.isNewData = payload;
  }
};
var actions = {
  setTelemetryData: function setTelemetryData(_ref2, payload) {
    var state = _ref2.state,
      commit = _ref2.commit,
      dispatch = _ref2.dispatch;
    // from signalMessage (websocket), 需要每分鐘更新的資料都塞這
    var querySiteName = state.querySiteName,
      minDataLastTime = state.minDataLastTime;
    var detail = payload.detail,
      factoryName = payload.factoryName;
    if (querySiteName === factoryName && detail.SYSTIME > minDataLastTime) {
      var _state$invAckwhRetent, _detail$etc, _detail$etc$LVMeter, _detail$etc2, _detail$etc2$HVMeter;
      // 時間
      commit('deviceStatus/SET_DATA_TIME', DateTime.fromSeconds(Number(detail.SYSTIME)).toFormat('yyyy-MM-dd HH:mm'));

      // 圖表 series.data
      commit('deviceStatus/SET_CHART_X_AXIS_CATEGORIES'); // 清空
      dispatch('deviceStatus/setXAxisCategories');

      // AC_kWh 每個加上換機保留發電量值 (websocket 的 AC_kWh 還沒加上換機保留發電量)
      var hasInvAckwhRetention = (_state$invAckwhRetent = state.invAckwhRetention.switchInverterIndex) === null || _state$invAckwhRetent === void 0 ? void 0 : _state$invAckwhRetent.length;
      if (hasInvAckwhRetention) {
        // console.log('AC_kWh 加上換機保留發電量值')
        for (var i = 0; i < state.invAckwhRetention.switchInverterIndex.length; i++) {
          var invIdx = state.invAckwhRetention.switchInverterIndex[i];
          var retained = getRetainedAckwh(state.invAckwhRetention.initAckwhValue[i]);
          detail.AC_kWh[invIdx] = Math.round((detail.AC_kWh[invIdx] + retained) * 100) / 100;
        }
      }
      commit('deviceStatus/SET_CHART_SERIES', [detail.AC_kWh, detail.E_today, detail.acp, detail.dcp]);

      // 圖表 Ymax setting
      if (detail.AC_kWh && detail.E_today && detail.acp) {
        var yAxisMaxArr = [Math.max.apply(Math, _toConsumableArray(detail.AC_kWh)) * 1.1,
        // AC_kWh
        Math.max.apply(Math, _toConsumableArray(detail.E_today)) * 2,
        // E_today
        Math.max.apply(Math, _toConsumableArray(detail.E_today)) * 2 // acp、dcp
        ];
        commit('deviceStatus/SET_CHART_Y_AXIS_MAX', yAxisMaxArr);
      }

      // 累積發電 & 今日發電
      var voltages = {
        accVal: dbDataHandle(calculate.sumValue(detail.AC_kWh)),
        todayVal: dbDataHandle(calculate.sumValue(detail.E_today))
      };
      commit('siteInfoDetail/SET_VOLTAGES', voltages);

      // 即時資訊
      var realTimeGrid = {
        irr: dbDataHandle(handleIRRArray(detail.IRR) * 1000, 0),
        moduleTemp: dbDataHandle(detail.PVTemp),
        lowCurrent: isNumber((_detail$etc = detail.etc) === null || _detail$etc === void 0 ? void 0 : (_detail$etc$LVMeter = _detail$etc['LV-meter']) === null || _detail$etc$LVMeter === void 0 ? void 0 : _detail$etc$LVMeter.P) ? dbDataHandle(detail.etc['LV-meter'].P) : '-',
        highCurrent: isNumber((_detail$etc2 = detail.etc) === null || _detail$etc2 === void 0 ? void 0 : (_detail$etc2$HVMeter = _detail$etc2['HV-meter']) === null || _detail$etc2$HVMeter === void 0 ? void 0 : _detail$etc2$HVMeter.P) ? dbDataHandle(detail.etc['HV-meter'].P) : '-'
      };
      commit('siteInfoDetail/SET_REALTIME_GRID', realTimeGrid);

      // dido
      commit('siteInfoDetail/SET_DIDO_STATUS', detail.etc.dido);

      // deviceStatus table Data
      commit('deviceStatus/SET_TABLE_DATA', renderTableData(detail));
      commit('SET_IS_NEW_DATA', !state.isNewData);
    }

    // 恢復連線更新畫面
    state.factoryData.forEach(function (item) {
      try {
        if (item.factoryName && item.factoryName === factoryName) {
          updateFactoryData(item, payload, 'IRR', 'PVTemp', 'Eff', 'acp', 'dcp', 'E_today', 'ErrorMessage', 'dataTimeFromNow');
        }
      } catch (error) {}
    });
  },
  setDidoStatus: function setDidoStatus(_ref3, payload) {
    var state = _ref3.state,
      commit = _ref3.commit;
    // from signalMessage (websocket), dido 獨立封包，一次一個 device 的完整腳位快照
    var didofactoryName = payload.didofactoryName,
      dido = payload.dido;
    if (state.querySiteName !== didofactoryName || !dido) return;
    Object.entries(dido).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        deviceName = _ref5[0],
        pins = _ref5[1];
      commit('siteInfoDetail/MERGE_DIDO_STATUS', _objectSpread({
        name: deviceName
      }, pins));
    });
  },
  updateSiteInfoDetailState: function updateSiteInfoDetailState(_ref6) {
    var state = _ref6.state,
      commit = _ref6.commit;
    var lastMonAcpIrr = state.lastMonAcpIrr,
      capacity = state.capacity,
      factoryData = state.factoryData,
      factoryInfo = state.factoryInfo,
      querySiteName = state.querySiteName;
    factoryData.forEach(function (item) {
      if (querySiteName === (item === null || item === void 0 ? void 0 : item.factoryName)) {
        var _item$etc, _item$etc$LVMeter, _item$etc2, _item$etc2$HVMeter;
        state.minDataLastTime = item.SYSTIME;

        // setTelemetryData 會判斷是否有 invAckwhRetention 值，否則要 AC_kWh 加上換機保留發電量值
        var findInvAckwhRetention = factoryInfo.find(function (f) {
          return f.factory === querySiteName;
        }).invAckwhRetention;
        commit('SET_INV_ACKWH_RETENTION', findInvAckwhRetention);

        // 累積發電 & 今日發電
        var voltages = {
          accVal: dbDataHandle(calculate.sumValue(item.AC_kWh)),
          todayVal: dbDataHandle(calculate.sumValue(item.E_today))
        };
        commit('siteInfoDetail/SET_VOLTAGES', voltages);

        // 即時資訊
        var realTimeGrid = {
          irr: dbDataHandle(handleIRRArray(item.IRR) * 1000, 0),
          moduleTemp: dbDataHandle(item.PVTemp),
          eToday: isNumber(lastMonAcpIrr === null || lastMonAcpIrr === void 0 ? void 0 : lastMonAcpIrr.IRR) ? dbDataHandle(lastMonAcpIrr.IRR) : '-',
          peak: isNumber(lastMonAcpIrr === null || lastMonAcpIrr === void 0 ? void 0 : lastMonAcpIrr.ACP) ? dbDataHandle(lastMonAcpIrr.ACP / capacity.reduce(function (a, b) {
            return a + b;
          })) : '-',
          pr: isNumber(lastMonAcpIrr === null || lastMonAcpIrr === void 0 ? void 0 : lastMonAcpIrr.PR) ? dbDataHandle(lastMonAcpIrr.PR * 100, 1) : '-',
          lowCurrent: isNumber((_item$etc = item.etc) === null || _item$etc === void 0 ? void 0 : (_item$etc$LVMeter = _item$etc['LV-meter']) === null || _item$etc$LVMeter === void 0 ? void 0 : _item$etc$LVMeter.P) ? dbDataHandle(item.etc['LV-meter'].P) : '-',
          highCurrent: isNumber((_item$etc2 = item.etc) === null || _item$etc2 === void 0 ? void 0 : (_item$etc2$HVMeter = _item$etc2['HV-meter']) === null || _item$etc2$HVMeter === void 0 ? void 0 : _item$etc2$HVMeter.P) ? dbDataHandle(item.etc['HV-meter'].P) : '-',
          envTemp: isNumber(item === null || item === void 0 ? void 0 : item.ENVTemp) ? dbDataHandle(item.ENVTemp) : '-',
          anemometer: isNumber(item === null || item === void 0 ? void 0 : item.Anemometer) ? dbDataHandle(item.Anemometer) : '-',
          windVane: isNumber(item.etc.wind_vane) ? getWindDirection(item.etc.wind_vane) + ' ' + dbDataHandle(item.etc.wind_vane) : '-',
          waterLevel: isNumber(item === null || item === void 0 ? void 0 : item.Waterlevel) ? dbDataHandle(item.Waterlevel) : '-'
        };
        commit('siteInfoDetail/SET_REALTIME_GRID', realTimeGrid);
      }
    });
  },
  updateDevicesStatusState: function updateDevicesStatusState(_ref7) {
    var state = _ref7.state,
      commit = _ref7.commit,
      dispatch = _ref7.dispatch;
    // 進入畫面時要觸發更新 state
    var factoryData = state.factoryData,
      factoryInfo = state.factoryInfo,
      querySiteName = state.querySiteName;
    if (factoryData) {
      factoryData.forEach(function (item) {
        if (querySiteName === (item === null || item === void 0 ? void 0 : item.factoryName)) {
          // 時間
          commit('deviceStatus/SET_DATA_TIME', DateTime.fromSeconds(Number(item.SYSTIME)).toFormat('yyyy-MM-dd HH:mm'));

          // 圖表 series.data
          commit('deviceStatus/SET_CHART_X_AXIS_CATEGORIES'); // 清空
          dispatch('deviceStatus/setXAxisCategories');

          // setTelemetryData 會判斷是否有 invAckwhRetention 值，否則要 AC_kWh 加上換機保留發電量值
          var findInvAckwhRetention = factoryInfo.find(function (f) {
            return f.factory === querySiteName;
          }).invAckwhRetention;
          commit('SET_INV_ACKWH_RETENTION', findInvAckwhRetention);

          // factoryData 獲得 getLastDocumentApi 的 AC_kWh 已有加上換機保留發電量值
          // 所以直接相加=累積發電
          item.AC_kWh = item.AC_kWh.map(function (v) {
            return Math.round(v * 10) / 10;
          });
          commit('deviceStatus/SET_CHART_SERIES', [item.AC_kWh, item.E_today, item.acp, item.dcp]);

          // table
          commit('deviceStatus/SET_TABLE_DATA', renderTableData(item));

          // 圖表 Ymax setting
          if (item.AC_kWh && item.E_today && item.acp) {
            var yAxisMaxArr = [Math.max.apply(Math, _toConsumableArray(item.AC_kWh)) * 1.1,
            // AC_kWh
            Math.max.apply(Math, _toConsumableArray(item.E_today)) * 2,
            // E_today
            Math.max.apply(Math, _toConsumableArray(item.E_today)) * 2 // acp、dcp
            ];
            commit('deviceStatus/SET_CHART_Y_AXIS_MAX', yAxisMaxArr);
          }
        }
      });
    }
  },
  // 外來監控 list
  asyncForeignFactoryList: function asyncForeignFactoryList(_ref8) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, _apiResult$data, _apiResult$data$data, apiResult, list;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref8.commit;
              _context.prev = 1;
              _context.next = 4;
              return getOtherSystemFactoriesApi();
            case 4:
              apiResult = _context.sent;
              if (apiResult !== null && apiResult !== void 0 && (_apiResult$data = apiResult.data) !== null && _apiResult$data !== void 0 && (_apiResult$data$data = _apiResult$data.data) !== null && _apiResult$data$data !== void 0 && _apiResult$data$data.length) {
                list = apiResult.data.data.sort(function (a, b) {
                  return Number(a.factoryId.slice(1)) - Number(b.factoryId.slice(1));
                });
                commit('ADD_FOREIGN_FACTORY_LIST', list);
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.log('asyncForeignFactoryList', _context.t0);
            case 11:
              _context.prev = 11;
              commit('CHANGE_GOT_FOREIGN_FACTORY_STATE', true);
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }))();
  },
  // 案場名稱排序 list
  asyncSortedFactories: function asyncSortedFactories(_ref9) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var commit, _apiResult$data2, _apiResult$data2$data, apiResult, apiRes, sortedList;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref9.commit;
              _context2.prev = 1;
              _context2.next = 4;
              return getSortedFactoriesApi();
            case 4:
              apiResult = _context2.sent;
              if (apiResult !== null && apiResult !== void 0 && (_apiResult$data2 = apiResult.data) !== null && _apiResult$data2 !== void 0 && (_apiResult$data2$data = _apiResult$data2.data) !== null && _apiResult$data2$data !== void 0 && _apiResult$data2$data.length) {
                apiRes = apiResult.data.data;
                sortedList = decryptData(apiRes);
                commit('ADD_SORTED_FACTORY_NAME_LIST', sortedList);
              }
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              console.log('asyncSortedFactories', _context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }))();
  },
  // 所有可觀看的資料 demo or factory 的 [ info ]
  asyncInfo: function asyncInfo(_ref10) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _state$sortedFactoryN;
      var state, commit, dispatch, sortedList, _factoriesInfo$data, _factoriesInfo$data$d, factoriesInfo, resultData, sortedInfo, sortedDemoList, sortedFactoriesList;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref10.state, commit = _ref10.commit, dispatch = _ref10.dispatch;
              if (state.realTimeDataReload) state.overlayShow = true;

              // check sorted factory name list
              if ((_state$sortedFactoryN = state.sortedFactoryNameList) !== null && _state$sortedFactoryN !== void 0 && _state$sortedFactoryN.length) {
                _context3.next = 5;
                break;
              }
              _context3.next = 5;
              return dispatch('asyncSortedFactories');
            case 5:
              sortedList = state.sortedFactoryNameList;
              _context3.prev = 6;
              _context3.next = 9;
              return getFactoriesInfoApi(queryFactoryList(state));
            case 9:
              factoriesInfo = _context3.sent;
              if (factoriesInfo !== null && factoriesInfo !== void 0 && (_factoriesInfo$data = factoriesInfo.data) !== null && _factoriesInfo$data !== void 0 && (_factoriesInfo$data$d = _factoriesInfo$data.data) !== null && _factoriesInfo$data$d !== void 0 && _factoriesInfo$data$d.length) {
                resultData = factoriesInfo.data.data.filter(function (item) {
                  return !item.isArchived;
                });
                sortedInfo = []; // has demo & factory
                // demo 排前面、兩者各自排序
                if (state.hasFactoryPermission && state.hasDemoPermission) {
                  sortedDemoList = [];
                  sortedFactoriesList = [];
                  resultData.forEach(function (item) {
                    var _state$userDetail$fac2;
                    if (state.userDetail.demoList.includes(item.factory)) {
                      sortedDemoList.push(item);
                    }
                    if (((_state$userDetail$fac2 = state.userDetail.factoriesList) === null || _state$userDetail$fac2 === void 0 ? void 0 : _state$userDetail$fac2[0]) === 'ALL') {
                      return sortedFactoriesList.push(item);
                    }
                    if (state.userDetail.factoriesList.includes(item.factory)) {
                      sortedFactoriesList.push(item);
                    }
                  });
                  sortedDemoList = sortedDemoList.sort(function (a, b) {
                    return a.queue - b.queue;
                  }).map(function (item, idx) {
                    var demo = Object.assign({}, item);
                    demo.isDemoSite = true;
                    demo.displaySiteName = "\u5C55\u793A\u6848\u5834 ".concat(idx + 1);
                    return demo;
                  });
                  sortedFactoriesList = sortedFactoriesList.sort(function (a, b) {
                    return sortedList.indexOf(a.factory) - sortedList.indexOf(b.factory);
                  }).map(function (item) {
                    var data = Object.assign({}, item);
                    data.displaySiteName = item.factory;
                    return data;
                  });
                  sortedInfo = [].concat(_toConsumableArray(sortedDemoList), _toConsumableArray(sortedFactoriesList));
                }

                // has only demo
                if (!state.hasFactoryPermission && state.hasDemoPermission) {
                  sortedInfo = resultData.sort(function (x, y) {
                    return x.queue - y.queue;
                  }).map(function (item, idx) {
                    var demo = Object.assign({}, item);
                    demo.isDemoSite = true;
                    demo.displaySiteName = "\u5C55\u793A\u6848\u5834 ".concat(idx + 1);
                    return demo;
                  });
                }

                // has only factory
                if (state.hasFactoryPermission && !state.hasDemoPermission) {
                  sortedInfo = resultData.sort(function (a, b) {
                    return sortedList.indexOf(a.factory) - sortedList.indexOf(b.factory);
                  }).map(function (item) {
                    var data = Object.assign({}, item);
                    data.displaySiteName = item.factory;
                    return data;
                  });
                }
                commit('ADD_FACTORY_INFO', sortedInfo);
              }
              _context3.next = 16;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](6);
              console.log(_context3.t0);
            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[6, 13]]);
    }))();
  },
  // 所有可觀看的資料中，要展示於 realtime 的 [ data ]
  // 一開始只顯示(call api) 10 筆(?)，往下 scroll 才顯示其他的
  asyncSpecificLastDoc: function asyncSpecificLastDoc(_ref11, ownerArr) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _lastDoc$data;
      var state, commit, filteredArr, lastDoc, isOwner, lastDocData, sortedData;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref11.state, commit = _ref11.commit;
              filteredArr = removeDuplicates(ownerArr, 'factory');
              _context4.next = 4;
              return getLastSpecificDocumentsApi(filteredArr);
            case 4:
              lastDoc = _context4.sent;
              if (lastDoc !== null && lastDoc !== void 0 && (_lastDoc$data = lastDoc.data) !== null && _lastDoc$data !== void 0 && _lastDoc$data.success) {
                isOwner = !state.hasRoleAdmin; // 業主專屬告警
                lastDocData = lastDoc.data.data;
                sortedData = [];
                ownerArr.forEach(function (item) {
                  if (item.isDemoSite) {
                    var _lastDocData$filter = lastDocData.filter(function (data) {
                        return data.factoryName === item.factory;
                      }),
                      _lastDocData$filter2 = _slicedToArray(_lastDocData$filter, 1),
                      useCopyObj = _lastDocData$filter2[0];
                    var insertDemo = Object.assign({}, useCopyObj);
                    var displayNum = item.displaySiteName.split(' ')[1];
                    insertDemo.isDemoSite = true;
                    insertDemo.displaySiteName = "\u5C55\u793A\u6848\u5834 ".concat(displayNum);
                    // 告警圖標 (admin / 業主)
                    insertDemo.displayAlertLevel = isOwner ? insertDemo.ownerAlertLevel : insertDemo.alertLevel;
                    return sortedData.push(insertDemo);
                  }
                  if (!item.isDemoSite) {
                    var _lastDocData$filter3 = lastDocData.filter(function (data) {
                        return data.factoryName === item.factory;
                      }),
                      _lastDocData$filter4 = _slicedToArray(_lastDocData$filter3, 1),
                      _useCopyObj = _lastDocData$filter4[0];
                    var insertFactory = Object.assign({}, _useCopyObj);
                    insertFactory.displaySiteName = item.factory;
                    // 告警圖標 (admin / 業主)
                    insertFactory.displayAlertLevel = isOwner ? insertFactory.ownerAlertLevel : insertFactory.alertLevel;
                    return sortedData.push(insertFactory);
                  }
                });
                commit('ADD_FACTORY_DATA', sortedData);
                state.overlayShow = false;
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  // siteinfo 內的 top menu 每頁 若重整，需取當頁案場資料
  asyncLastSingleDoc: function asyncLastSingleDoc(_ref12, siteName) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _router$history$curre, _LastSingleDoc$data;
      var state, commit, isDemo, demoIndex, LastSingleDoc, _LastSingleDoc$data$d, _LastSingleDoc$data$d2, _LastSingleDoc$data$d3, _LastSingleDoc$data$d4;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = _ref12.state, commit = _ref12.commit;
              isDemo = (_router$history$curre = router.history.current.query.siteName) === null || _router$history$curre === void 0 ? void 0 : _router$history$curre.includes('展示案場 ');
              if (isDemo) {
                demoIndex = siteName.split(' ')[1] - 1;
                siteName = state.factoryInfo[demoIndex].factory;
              }
              _context5.next = 5;
              return getLastDocumentApi(siteName);
            case 5:
              LastSingleDoc = _context5.sent;
              if (LastSingleDoc !== null && LastSingleDoc !== void 0 && (_LastSingleDoc$data = LastSingleDoc.data) !== null && _LastSingleDoc$data !== void 0 && _LastSingleDoc$data.success) {
                state.factoryData = [(_LastSingleDoc$data$d = LastSingleDoc.data.data) === null || _LastSingleDoc$data$d === void 0 ? void 0 : (_LastSingleDoc$data$d2 = _LastSingleDoc$data$d[0]) === null || _LastSingleDoc$data$d2 === void 0 ? void 0 : _LastSingleDoc$data$d2.detail];
                commit('LAST_MON_ACP_IRR', (_LastSingleDoc$data$d3 = LastSingleDoc.data.data) === null || _LastSingleDoc$data$d3 === void 0 ? void 0 : (_LastSingleDoc$data$d4 = _LastSingleDoc$data$d3[0]) === null || _LastSingleDoc$data$d4 === void 0 ? void 0 : _LastSingleDoc$data$d4.PrRaMon);
                commit('UPDATE_DATA_ANALYSIS_STATE');
              } else {
                commit('RESET_FACTORY_DATA');
              }
            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  getAllGroups: function getAllGroups(_ref13) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var commit;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref13.commit;
              _context6.next = 3;
              return getAllGroupsApi().then(function (_ref14) {
                var data = _ref14.data;
                commit('SET_ROLE_ARRAY', data.data);
                commit('UPDATE_ROLE_ARRAY');
                commit('SET_PROJECTS');
              }).catch(function (err) {
                return console.log('getAllGroups', err);
              });
            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  getAllAlarm: function getAllAlarm(_ref15) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var commit, _apiResult$data3, _apiResult$data3$data, apiResult, apiRes, alarmData;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref15.commit;
              _context7.prev = 1;
              _context7.next = 4;
              return getAllAlarmsApi();
            case 4:
              apiResult = _context7.sent;
              if (apiResult !== null && apiResult !== void 0 && (_apiResult$data3 = apiResult.data) !== null && _apiResult$data3 !== void 0 && (_apiResult$data3$data = _apiResult$data3.data) !== null && _apiResult$data3$data !== void 0 && _apiResult$data3$data.length) {
                apiRes = apiResult.data.data;
                alarmData = decryptData(apiRes);
                commit('ADD_ALARM_DATA', alarmData);
              }
              _context7.next = 11;
              break;
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](1);
              console.log('getAllAlarm', _context7.t0);
            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 8]]);
    }))();
  }
};
export default new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {
    siteInfoDetail: siteInfoDetail,
    deviceStatus: deviceStatus,
    deviceHistory: deviceHistory,
    ChartsAndBarItem: ChartsAndBarItem,
    pvStringFailure: pvStringFailure,
    projectEnergy: projectEnergy
  }
  // strict: process.env.NODE_ENV !== 'production'
});